export async function enableMocking() {
  if (import.meta.env.MODE !== 'test') {
    return;
  }

  const { worker } = await import('./api/browser');

  return worker.start({
    quiet: true,
  });
}
